// Revisado: 2026-02-21 [I18n Scan] - [Meta SEO y UI]
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Routes, Route } from 'react-router-dom';
import FadeIn from '../shared/FadeIn';
import SEO from '../shared/SEO';
import MiniGamesHubHeader from './MiniGamesHubHeader';

// Auto-loaded games
import games from './games/GameLoader';

const GameGrid = () => {
    const { t } = useTranslation();

    return (
        <FadeIn>
            <SEO title={t('MetaMiniGamesHub.title')} description={t('MetaMiniGamesHub.description')} />
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white p-6 relative overflow-hidden transition-colors duration-300">
                {/* Background Decor */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-10 dark:opacity-20 transition-opacity duration-300">
                    <div className="absolute top-10 left-10 w-64 h-64 bg-purple-400 dark:bg-purple-600 rounded-full blur-[100px] transition-colors duration-300"></div>
                    <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-400 dark:bg-blue-600 rounded-full blur-[100px] transition-colors duration-300"></div>
                </div>

                <div className="max-w-6xl mx-auto relative z-10">
                    <MiniGamesHubHeader />

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                        {/* Dynamic Games */}
                        {games.length > 0 ? games.map((game) => (
                            <Link key={game.id} to={game.id} className="block group">
                                <div className={`relative bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm border border-gray-200 dark:border-gray-700 rounded-2xl overflow-hidden hover:border-${game.color || 'purple'}-400 dark:hover:border-${game.color || 'purple'}-500/50 transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,0,0,0.05)] dark:hover:shadow-[0_0_20px_rgba(255,255,255,0.1)] h-full`}>
                                    <div className="h-48 bg-gray-100/50 dark:bg-gray-900/50 flex items-center justify-center relative overflow-hidden transition-colors duration-300">
                                        <div className="text-6xl group-hover:scale-110 transition-transform duration-300">
                                            {game.icon || '🎮'}
                                        </div>
                                        <div className="absolute inset-0 bg-gradient-to-t from-gray-200 dark:from-gray-900 to-transparent transition-colors duration-300"></div>
                                    </div>
                                    <div className="p-6 transition-colors duration-300">
                                        <h3 className={`text-2xl font-bold text-gray-800 dark:text-white mb-2 group-hover:text-${game.color || 'purple'}-500 dark:group-hover:text-${game.color || 'purple'}-400 transition-colors`}>
                                            {game.title_key ? t(game.title_key) : game.title}
                                        </h3>
                                        <p className="text-gray-500 dark:text-gray-400 text-sm mb-4 transition-colors">
                                            {game.desc_key ? t(game.desc_key) : game.description}
                                        </p>
                                        <div className="w-full py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white rounded-lg text-center font-bold text-sm group-hover:bg-gray-300 dark:group-hover:bg-gray-600 transition-colors">
                                            {t('MiniGamesHub.play_now', 'PLAY NOW')}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )) : (
                            <div className="col-span-full text-center text-gray-500 py-10">
                                {t('MiniGamesHub.no_games', 'No games found. Add files to src/components/MiniGames/games/')}
                            </div>
                        )}

                        {/* Placeholder for future games */}
                        <div className="group relative bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm border border-gray-300 dark:border-gray-700 rounded-2xl overflow-hidden cursor-not-allowed border-dashed opacity-60 transition-colors duration-300">
                            <div className="h-48 bg-gray-200/50 dark:bg-gray-900/50 flex items-center justify-center transition-colors duration-300">
                                <div className="text-6xl text-gray-400 dark:text-gray-600 transition-colors duration-300">?</div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-2xl font-bold text-gray-500 dark:text-gray-400 mb-2 transition-colors duration-300">
                                    {t('MiniGamesHub.more_soon_title', 'More Soon')}
                                </h3>
                                <p className="text-gray-500 dark:text-gray-400 text-sm transition-colors duration-300">
                                    {t('MiniGamesHub.more_soon_text', 'Check back later!')}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </FadeIn>
    );
};

const MiniGamesHub = () => {
    return (
        <Routes>
            <Route index element={<GameGrid />} />
            {games.map((game) => (
                <Route
                    key={game.id}
                    path={game.id}
                    element={
                        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white p-6 relative transition-colors duration-300">
                            {/* Game Component Render */}
                            <game.Component />
                        </div>
                    }
                />
            ))}
        </Routes>
    );
};

export default MiniGamesHub;
